/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link, useNavigate } from "react-router-dom";
import {
  GetService,
  PostFormData,
  PostService,
} from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import CustomImageBlocks from "./CustomImageBlocks";
import { BounceLoader } from "react-spinners";
import Login from "../Login/Login";
import ForgotPassword from "../Forgot-Password/ForgotPassword";
import CustomBlocksStoryCanvas from "./CustomBlocksStoryCanvas";
import CustomBlocksSplitCanvas from "./CustomBlocksSplitCanvas/CustomBlocksSplitCanvas";
import CustomBlocksSingleCanvas from "./CustomBlocksSingleCanvas";
import CustomBlocksArtTray from "./CustomBlocksArtTray";
import { toastEmmit } from "../../../Helper/Toastr";

export default function CustomNew() {
  const Token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("London");

  const openCity = (event, cityName) => {
    // Your logic for opening the city
    // setActiveTab(cityName);
    if (SelectedLayout === "split_canvas") {
      getSize("split_canvas", cityName);
    }
  };

  const [SubcategoryTab, setSubcategoryTab] = useState(false);
  const [SingleFrameCategoryTab, setSingleFrameCategoryTab] = useState(false);
  const [SelectedLayout, setSelectedLayout] = useState("");
  const [Clicked, setClicked] = useState(false);
  const [AddToCartTrigger, setAddToCartTrigger] = useState(false);
  const [SelectedSizeValue, setSelectedSizeValue] = useState("");
  const [AllSelectedImages, setAllSelectedImages] = useState([]);
  const [MergedBlobImage, setMergedBlobImage] = useState("");
  const [EnableDisableAddToCart, setEnableDisableAddToCart] = useState(false);
  const [loading, setLoading] = useState(false);
  // let [Token, setToken] = useState(localStorage.getItem('token'));
  const [LoginModalOpen, setLoginModalOpen] = useState(false);
  const [SizeDataObject, setSizeDataObject] = useState({});
  const [Edge, setEdge] = useState("");
  const [Services, setServices] = useState({
    Effects: { name: "", price: "" },
    Retouching: { name: "", price: "" },
  });

  const [EdgeListing, setEdgeListing] = useState([]);
  const [FramedEdgeListing, setFramedEdgeListing] = useState([]);
  const [ServicesListing, setServicesListing] = useState([]);

  useEffect(() => {
    GetFramedEdgeListing();
  }, []);

  function GetEdgesListing() {
    GetService(API_URL.GET_EDGE_LISTING).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setEdgeListing(res?.data?.data);
      } else {
        toastEmmit("error", res?.data?.message);
      }
    });
  }

  function GetFramedEdgeListing() {
    GetService(API_URL.GET_FRAMED_EDGE_LISTING).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setFramedEdgeListing(res?.data?.data);
      } else {
        toastEmmit("error", res?.data?.message);
      }
    });
  }

  function GetServicesListing() {
    GetService(`${API_URL.GET_SERVICES_LISTING}?type=${SelectedLayout}`).then(
      (res) => {
        console.log(res);
        if (res?.data?.status) {
          setServicesListing(res?.data?.data);
        } else {
          toastEmmit("error", res?.data?.message);
        }
      }
    );
  }

  useEffect(() => {
    // console.log(SelectedSizeValue);
    setAddToCartTrigger(false);
  }, [SelectedSizeValue]);

  // console.log('first')

  useEffect(() => {
    // console.log(SelectedLayout);
    if (SelectedLayout) {
      document.getElementById("pills-Tab3-tab").click();
      // setSelectedSizeValue("")
      GetEdgesListing();
      GetServicesListing();
    }
  }, [SelectedLayout, Clicked]);

  const [SelectedImages, SetSelectedImages] = useState([]);

  function OnImageChange(e) {
    // console.log(e.target.files);
    // SetSelectedImages([...SelectedImages, ...e.target.files]);

    const files = e.target.files;
    const newImages = [];
    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();

      reader.onload = (e) => {
        newImages.push(e.target.result);
        // If all files have been processed, update state
        if (newImages.length === files.length) {
          // SetSelectedImages([...SelectedImages, ...newImages]);
          SetSelectedImages(newImages);
        }
      };
      reader.readAsDataURL(files[i]);
    }
  }
  // console.log(SelectedImages);

  const [SizeList, setSizeList] = useState([]);
  const [FrameOption, setFrameOption] = useState("");

  function getSize(type, tab) {
    setFrameOption(type === "single_panel" ? tab : "");
    setLoading(true);
    const obj = {
      single_panel: `${API_URL.GET_SINGLEPANELSIZE_LIST}?rowName=${tab}`,
      gallery_wall: API_URL.GET_GALLERYWALLSIZE_LIST,
      split_canvas: API_URL.GET_SPLITCANVASSIZE_LIST,
      story_canvas: API_URL.GET_STORYCANVAS_LIST,
      diamond_dust: `${API_URL.GET_ARTTRAY_LIST}?type=diamond_dust`,
      art_tray: `${API_URL.GET_ARTTRAY_LIST}?type=art_tray`,
      plexi_print: `${API_URL.GET_ARTTRAY_LIST}?type=plexi_print`,
      wood_print: `${API_URL.GET_ARTTRAY_LIST}?type=wood_print`,
    };
    if (type !== "split_canvas") {
      GetService(obj[type]).then((res) => {
        console.log(res);
        if (res?.data?.status) {
          setSizeList(res?.data?.data);
          setSelectedSizeValue(res?.data?.data[0]);
          setSelectedLayout(type);
          setClicked(!Clicked);
        }
        setLoading(false);
      });
    } else {
      console.log(activeTab);
      const data = { type: tab === "London" ? 2 : 3 };
      PostService(obj[type], data).then((res) => {
        // console.log(res);
        if (res?.data?.status) {
          setSizeList(res?.data?.data);
          // setSizeDataObject({
          //   id: res?.data?.data[0]?.id ,
          //   panels: res?.data?.data[0]?.panels,
          //   price: res?.data?.data[0]?.price,
          //   size: res?.data?.data[0]?.size
          // })
          setSelectedSizeValue({
            id: res?.data?.data[0]?.id,
            panels: res?.data?.data[0]?.panels,
            price: res?.data?.data[0]?.price,
            size: res?.data?.data[0]?.size,
          });
          // setSelectedLayout(type);
          setClicked(!Clicked);
        }
        setLoading(false);
      });
    }
  }

  const onImagesFromChild = (ImagesFromChild) => {
    console.log(ImagesFromChild);
    if (ImagesFromChild) {
      if (ImagesFromChild.every((image) => image !== "")) {
        setEnableDisableAddToCart(true);
        setAllSelectedImages(ImagesFromChild);
      } else {
        setEnableDisableAddToCart(false);
        setAllSelectedImages([]);
      }
    } else {
      setEnableDisableAddToCart(false);
      setAllSelectedImages([]);
    }
  };

  const BlobImageFromChild = (blob) => {
    if (blob) {
      setMergedBlobImage(blob);
      SubmitAddToCart(blob);
    }
    // console.log(blob)
  };

  const CheckUserLogin = () => {
    const token = localStorage.getItem("token");
    //  setToken(token)
    if (token) {
      setLoading(true);
      setAddToCartTrigger(true);
    }
  };

  const SubmitAddToCart = (blob) => {
    // console.log(SelectedLayout);
    // console.log(AllSelectedImages);
    // console.log(SelectedSizeValue);
    // console.log(FrameOption);

    const Formdata = new FormData();
    Formdata.append("Layout", SelectedLayout);
    if (SelectedLayout === "single_panel") {
      Formdata.append("type", FrameOption);
    }
    Formdata.append("SizeDetail", JSON.stringify(SelectedSizeValue));
    Formdata.append("quantity", 1);
    for (let i = 0; i < AllSelectedImages.length; i++) {
      const element = AllSelectedImages[i];
      Formdata.append("images", element);
    }
    Formdata.append("MergedImage", blob);
    Formdata.append("Edge", Edge ? JSON.stringify(Edge) : "");
    Formdata.append("Services", JSON.stringify(Services));

    PostFormData(API_URL.ADD_TO_CART, Formdata).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setLoading(false);
        navigate("/add-to-cart");
      } else {
        toastEmmit("error", `Server Error - ${res?.data?.message}`);
        setAddToCartTrigger(false);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    setEdge("");
    setServices({
      Effects: { name: "", price: "" },
      Retouching: { name: "", price: "" },
    });
  }, [SelectedLayout, FrameOption]);

  const [isTab5Active, setIsTab5Active] = useState(false);

  function ChangeTabBlocks() {
    const tab2 = document.getElementById("pills-Tab2-tab");
    const tab3 = document.getElementById("pills-Tab3-tab");
    const tab4 = document.getElementById("pills-Tab4-tab");
    const tab5 = document.getElementById("pills-Tab5-tab");

    if (SelectedSizeValue) {
      if (tab3.classList.contains("active")) {
        tab4.click();
      }else if (tab4.classList.contains("active")){
        tab5.click();
        setIsTab5Active(true)
      }else if(tab2.classList.contains("active")){
        tab3.click();
      }
    }
  }
  

  return (
    <>
      <div className="enhancements prices prices-one Print checkout">
        <main>
          <div className="tp-trend-product-5__area pb-10">
            <div className="container-fluid">
              <div className="row">
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade active show"
                    id="nav-Cards"
                    role="tabpanel"
                    aria-labelledby="nav-Cards-tab"
                    tabIndex={0}
                  >
                    <div className="Section3   pb-30 two">
                      <div className="container-fluid">
                        <div className="row">
                        <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 left-section">
                            <div className="row lower-btn">
                              <div className="col-12 d-flex  pt-10 pb-5" style={{borderBottom:'1px solid #e3e3e3',background:'white'}}>
                                <h6 className="mb-0 ms-1 d-flex align-items-center text-primary text-decoration-underline"> 
                                    <Link to={"/home"}>
                                    <i class="fa-solid fa-circle-arrow-left"></i> Home 
                                    </Link> 
                                </h6>
                                <h6 className="mt-2 heading-connect main ml-30"> 
                                  Create{" "}
                                  {SelectedLayout
                                    ? SelectedLayout === "gallery_wall"
                                      ? "Gallery Wall"
                                      : SelectedLayout === "story_canvas"
                                      ? "Story Canvas"
                                      : SelectedLayout === "split_canvas"
                                      ? "Split Canvas"
                                      : SelectedLayout === "single_panel"
                                      ? FrameOption
                                        ? FrameOption === "thinGallery"
                                          ? "Thin Gallery Wrap"
                                          : FrameOption === "thickGallery"
                                          ? "Thick Gallery Wrap"
                                          : FrameOption === "framed"
                                          ? "Framed"
                                          : FrameOption === "rolled"
                                          ? "Rolled in a Tube"
                                          : ""
                                        : ""
                                      : SelectedLayout === "plexi_print"
                                      ? "Plexi Print"
                                      : SelectedLayout === "art_tray"
                                      ? "Art Tray"
                                      : SelectedLayout === "wood_print"
                                      ? "Wood Print"
                                      : SelectedLayout === "diamond_dust"
                                      ? "Diamond Dust"
                                      : "-"
                                    : "Canvas Print"}
                                </h6>
                              </div>
                              <div className="col-xl-8 col-lg-8 col-md-12 m-auto text-right action-btn d-none">
                                <a className="tp-btn-lg large head mt-10 mb-10 d-none">
                                  <span>
                                    <i className="fa fa-trash" />
                                  </span>
                                  Reset
                                </a>
                                <a
                                  className="tp-btn-lg large head mt-10 d-none"
                                  href="#"
                                >
                                  <span>
                                    <i className="fa fa-undo" />
                                  </span>
                                  Undo
                                </a>
                                <a
                                  className="tp-btn-lg large head mb-10 d-none"
                                  href="#"
                                >
                                  <span>
                                    <i className="fa fa-repeat" />
                                  </span>
                                  Redo
                                </a>
                                <a
                                  className="tp-btn-lg large head mt-10 d-none"
                                  href="#"
                                >
                                  <span>
                                    <i className="fa fa-eye" />
                                  </span>
                                  Preview
                                </a>
                              </div>
                            </div>

                            {SelectedLayout === "gallery_wall" &&
                            SelectedSizeValue ? (
                              // CustomImageBlocks refers to Gallery Walls part blocks
                              <CustomImageBlocks
                                selectedSize={SelectedSizeValue}
                                addToCartTriggered={AddToCartTrigger}
                                sendAllSelectedImages={onImagesFromChild}
                                sendblobImage={BlobImageFromChild}
                              />
                            ) : SelectedLayout === "story_canvas" &&
                              SelectedSizeValue ? (
                              <CustomBlocksStoryCanvas
                                selectedSize={SelectedSizeValue}
                                addToCartTriggered={AddToCartTrigger}
                                sendAllSelectedImages={onImagesFromChild}
                                sendblobImage={BlobImageFromChild}
                              />
                            ) : SelectedLayout === "split_canvas" &&
                              SelectedSizeValue ? (
                              <CustomBlocksSplitCanvas
                                selectedSize={SelectedSizeValue}
                                addToCartTriggered={AddToCartTrigger}
                                sendAllSelectedImages={onImagesFromChild}
                                sendblobImage={BlobImageFromChild}
                              />
                            ) : SelectedLayout === "single_panel" &&
                              SelectedSizeValue ? (
                              <CustomBlocksSingleCanvas
                                selectedSize={SelectedSizeValue}
                                addToCartTriggered={AddToCartTrigger}
                                sendAllSelectedImages={onImagesFromChild}
                                sendblobImage={BlobImageFromChild}
                              />
                            ) : (SelectedLayout === "art_tray" ||
                                SelectedLayout === "wood_print" ||
                                SelectedLayout === "plexi_print" ||
                                SelectedLayout === "diamond_dust") &&
                              SelectedSizeValue ? (
                              <CustomBlocksArtTray
                                selectedSize={SelectedSizeValue}
                                addToCartTriggered={AddToCartTrigger}
                                sendAllSelectedImages={onImagesFromChild}
                                sendblobImage={BlobImageFromChild}
                              />
                            ) : (
                              <div className="frame-container">
                                <img
                                  src={
                                    // SelectedImages[0] || ""
                                    // "assets/img/blog/thumb.png"
                                    ""
                                  }
                                  alt=""
                                  style={{
                                    objectFit: "contain",
                                    maxWidth: "100%",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 left-art" style={{paddingLeft:'0px'}}>
                            <div className="Multi-tabs">
                              <ul
                                className="nav nav-pills"
                                id="pills-tab"
                                role="tablist"
                              >
                                <li
                                  className="nav-item d-flex"
                                  role="presentation"
                                >
                                  <button
                                    className="nav-link btn-md-sm active py-1"
                                    id="pills-Tab2-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab2"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-tab2"
                                    aria-selected="true"
                                    onClick={()=>setIsTab5Active(false)}
                                  >
                                    <div className="image">
                                      <img
                                        src="assets/img/breadcrumb/Layout.png"
                                        alt
                                      />
                                    </div>
                                    <div className="riht-content ">
                                      <span className="left">
                                        <p className="mb-0">Layout</p>
                                      </span>
                                    </div>
                                  </button>
                                </li>

                                <li
                                  className="nav-item list-inline-item d-flex"
                                  role="presentation"
                                >
                                  <button
                                    className="nav-link btn-md-sm py-1"
                                    id="pills-Tab3-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab3"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-tab3"
                                    aria-selected="false"
                                    onClick={()=>setIsTab5Active(false)}
                                  >
                                    <div className="image">
                                      <img
                                        src="assets/img/breadcrumb/size.png"
                                        alt
                                      />
                                    </div>
                                    <div className="riht-content  ">
                                      <span className="left">
                                        <p className="mb-0">Sizes</p>
                                      </span>
                                    </div>
                                  </button>
                                </li>

                                {/* <li
                                  className="nav-item d-flex"
                                  role="presentation"
                                >
                                  <button
                                    className="nav-link btn"
                                    id="pills-Tab1-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab1"
                                    type="button"
                                    role="tab "
                                    aria-controls="pills-tab1"
                                    aria-selected="false"
                                  >
                                    <div className="image">
                                      <img
                                        src="assets/img/breadcrumb/photos.png"
                                        alt
                                      />
                                    </div>
                                    <div className="riht-content mt-10">
                                      <span className="left">
                                        <p className="mb-0">Photos</p>
                                      </span>
                                    </div>
                                  </button>
                                </li> */}

                                <li
                                  className="nav-item list-inline-item d-flex"
                                  role="presentation"
                                >
                                  <button
                                    className="nav-link btn-md-sm py-1"
                                    id="pills-Tab4-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab4 "
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-tab4"
                                    aria-selected="false"
                                    onClick={()=>setIsTab5Active(false)}
                                  >
                                    <div className="image">
                                      <img
                                        src="assets/img/breadcrumb/Edge.png"
                                        alt
                                      />
                                    </div>
                                    <div className="riht-content ">
                                      <span className="left">
                                        <p className="mb-0">{FrameOption === "framed" ? 'Frames' : 'Edges'}</p>
                                      </span>
                                    </div>
                                  </button>
                                </li>

                                <li
                                  className="nav-item list-inline-item d-flex"
                                  role="presentation"
                                >
                                  <button
                                    className="nav-link btn-md-sm py-1"
                                    id="pills-Tab5-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-tab5 "
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-tab5"
                                    aria-selected="false"
                                    onClick={()=>{
                                      if (SelectedLayout && SelectedSizeValue && EnableDisableAddToCart) {
                                        setIsTab5Active(true);
                                    }
                                    }}
                                  >
                                    <div className="image">
                                      <img
                                        src="assets/img/breadcrumb/Services.png"
                                        alt
                                      />
                                    </div>
                                    <div className="riht-content ">
                                      <span className="left">
                                        <p className="mb-0">Services</p>
                                      </span>
                                    </div>
                                  </button>
                                </li>
                              </ul>

                              <div
                                className="tab-content"
                                id="pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  id="pills-tab2"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab2-tab"
                                >
                                  <div className="content-section layout">
                                    {!SubcategoryTab &&
                                      !SingleFrameCategoryTab && (
                                        // <div className="row unselect canvas_category_height first-li">
                                        <div className="row unselect table-wrapper-scroll-y tab-height first-li">
                                          <h6 className="heading mt-3 mb-3">
                                            Select Category
                                          </h6>
                                          <div
                                            className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                            style={{ paddingRight: 7 }}
                                          >
                                            <div className="tp-catagori-2__content-box pointer mb-15">
                                              <div
                                                className="tp-catagori-2__content plr text-center"
                                                onClick={() =>
                                                  setSubcategoryTab(true)
                                                }
                                              >
                                                <img
                                                  className="w-32"
                                                  src="assets/img/blog/bop-1.png"
                                                  alt
                                                />
                                                <h4 className="tp-catagori-2__title text-white">
                                                  Canvas print
                                                </h4>
                                                <p>
                                                  Upload photos, choose a size,
                                                  and we’ll ship your beautiful
                                                  canvas prints to your door.
                                                </p>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                            style={{ paddingLeft: 7 }}
                                          >
                                            <div className="tp-catagori-2__content-box pointer mb-15">
                                              <div
                                                className="tp-catagori-2__content plr text-center"
                                                onClick={() => {
                                                  getSize("diamond_dust");
                                                }}
                                              >
                                                <img
                                                  className="w-32"
                                                  src="assets/img/blog/bop-5.png"
                                                  alt
                                                />
                                                <h4 className="tp-catagori-2__title text-white">
                                                Diamond Dust
                                                </h4>
                                                <p>
                                                  Upload photos and we’ll ship your beautiful
                                                  Diamond frame to your door.
                                                </p>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                            style={{ paddingRight: 7 }}
                                          >
                                            <div className="tp-catagori-2__content-box pointer mb-15">
                                              <div
                                                className="tp-catagori-2__content plr text-center"
                                                // onClick={() => {
                                                //   setSelectedLayout(
                                                //     "plexi_print"
                                                //   );
                                                //   setClicked(!Clicked);
                                                // }}
                                                onClick={() => {
                                                  getSize("plexi_print");
                                                }}
                                              >
                                                <img
                                                  className="w-32"
                                                  src="assets/img/blog/bop-2.png"
                                                  alt
                                                />
                                                <h4 className="tp-catagori-2__title text-white">
                                                  Plexi print
                                                </h4>
                                                <p>
                                                  Upload photos, choose a size,
                                                  and we’ll ship your beautiful
                                                  plexi prints to your door.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                            style={{ paddingLeft: 7 }}
                                          >
                                            <div className="tp-catagori-2__content-box pointer mb-15">
                                              <div
                                                className="tp-catagori-2__content plr text-center"
                                                // onClick={() => {
                                                //   setSelectedLayout("art_tray");
                                                //   setClicked(!Clicked);
                                                // }}
                                                onClick={() => {
                                                  getSize("art_tray");
                                                }}
                                              >
                                                <img
                                                  className="w-32"
                                                  src="assets/img/blog/bop-3.png"
                                                  alt
                                                />
                                                <h4 className="tp-catagori-2__title text-white">
                                                  Art tray
                                                </h4>
                                                <p>
                                                  Upload photos, choose a size,
                                                  and we’ll ship your beautiful
                                                  art prints to your door.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                            style={{ paddingRight: 7 }}
                                          >
                                            <div className="tp-catagori-2__content-box pointer mb-15">
                                              <div
                                                className="tp-catagori-2__content plr text-center"
                                                // onClick={() => {
                                                //   setSelectedLayout("wood");
                                                //   setClicked(!Clicked);
                                                // }}
                                                onClick={() => {
                                                  getSize("wood_print");
                                                }}
                                              >
                                                <img
                                                  className="w-32"
                                                  src="assets/img/blog/bop-4.png"
                                                  alt
                                                />
                                                <h4 className="tp-catagori-2__title text-white">
                                                  Print on wood
                                                </h4>
                                                <p>
                                                  Upload photos, choose a size,
                                                  and we’ll ship your beautiful
                                                  wood prints to your door.
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                    {SubcategoryTab && (
                                      <div className="row unselect table-wrapper-scroll-y tab-height first-li">
                                        <h6 className="heading mt-3 mb-3">
                                          <span style={{ marginRight: "10px" }}>
                                            <i
                                              className="fa fa-arrow-left pointer"
                                              onClick={() =>
                                                setSubcategoryTab(false)
                                              }
                                            />
                                          </span>
                                          Select Sub-Category
                                        </h6>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingRight: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center sub-cat-box-height"
                                              onClick={() => {
                                                setSingleFrameCategoryTab(true);
                                                setSubcategoryTab(false);
                                                // getSize("single_panel");
                                              }}
                                            >
                                              <img
                                                className="w-32"
                                                src="assets/img/blog/bop-1.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Single Canvas
                                              </h4>
                                              <p>
                                              Create your masterpiece on a single canvas with many options to choose from.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingLeft: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center sub-cat-box-height"
                                              onClick={() => {
                                                getSize(
                                                  "split_canvas",
                                                  "London"
                                                );
                                                setActiveTab("London");
                                                setSelectedLayout(
                                                  "split_canvas"
                                                );
                                              }}
                                            >
                                              <img
                                                className="w-32"
                                                src="assets/img/blog/split-canvas.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Split canvas
                                              </h4>
                                              <p>
                                              Split your photo or art into canvases creating a unique art piece.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingRight: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center sub-cat-box-height"
                                              onClick={() => {
                                                getSize("gallery_wall");
                                              }}
                                            >
                                              <img
                                                className="w-32"
                                                src="assets/img/blog/gallery-wall.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Gallery wall
                                              </h4>
                                              <p>
                                              Create a gallery wall with multiple individual canvases.
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingLeft: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center sub-cat-box-height"
                                              onClick={() => {
                                                getSize("story_canvas");
                                                setSelectedLayout(
                                                  "story_canvas"
                                                );
                                              }}
                                            >
                                              <img
                                                className="w-32"
                                                src="assets/img/blog/story-canvs-tab.svg"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                {/* Rolled in a tube */} Story
                                                Canvas
                                              </h4>
                                              <p>
                                              Multiple photos on one canvas creating a story of your unforgetable memories.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {SingleFrameCategoryTab && (
                                      <div className="row unselect table-wrapper-scroll-y tab-height first-li">
                                        <h6 className="heading mt-3 mb-3">
                                          <span style={{ marginRight: "10px" }}>
                                            <i
                                              className="fa fa-arrow-left pointer"
                                              onClick={() => {
                                                setSingleFrameCategoryTab(
                                                  false
                                                );
                                                setSubcategoryTab(true);
                                              }}
                                            />
                                          </span>
                                          Select Single Option
                                        </h6>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingRight: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center"
                                              onClick={() => {
                                                getSize(
                                                  "single_panel",
                                                  "thinGallery"
                                                );
                                              }}
                                            >
                                              <img
                                                className="SingleCategoryTab_Img"
                                                src="assets/img/breadcrumb/Thin_Gallery.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Thin Gallery Wrap (0.75)
                                              </h4>
                                              <p>
                                                Upload photos, choose a size,
                                                and we’ll ship your beautiful
                                                canvas prints to your door.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingLeft: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center"
                                              onClick={() => {
                                                getSize(
                                                  "single_panel",
                                                  "thickGallery"
                                                );
                                              }}
                                            >
                                              <img
                                                className="SingleCategoryTab_Img"
                                                src="assets/img/breadcrumb/Thick_Gallery.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Thick Gallery Wrap (1.5)
                                              </h4>
                                              <p>
                                                Upload photos, choose a size,
                                                and we’ll ship your beautiful
                                                canvas prints to your door.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingRight: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center"
                                              onClick={() => {
                                                getSize(
                                                  "single_panel",
                                                  "framed"
                                                );
                                              }}
                                            >
                                              <img
                                                className="SingleCategoryTab_Img"
                                                src="assets/img/breadcrumb/Framed.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Framed
                                              </h4>
                                              <p>
                                                Upload photos, choose a size,
                                                and we’ll ship your beautiful
                                                canvas prints to your door.
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                          style={{ paddingLeft: 7 }}
                                        >
                                          <div className="tp-catagori-2__content-box pointer mb-15">
                                            <div
                                              className="tp-catagori-2__content plr text-center"
                                              onClick={() => {
                                                getSize(
                                                  "single_panel",
                                                  "rolled"
                                                );
                                              }}
                                            >
                                              <img
                                                className="SingleCategoryTab_Img"
                                                src="assets/img/breadcrumb/Rolled.png"
                                                alt
                                              />
                                              <h4 className="tp-catagori-2__title text-white">
                                                Rolled in a Tube
                                              </h4>
                                              <p>
                                                Upload photos, choose a size,
                                                and we’ll ship your beautiful
                                                canvas prints to your door.
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-tab3"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab3-tab"
                                >
                                  <div
                                    className="tab-content"
                                    id="pills-tabContent"
                                  >
                                    <div className="table-wrapper-scroll-y tab-height first-li"> 
                                      {
                                        <>
                                         {/* Tab content */}
                                          {SelectedLayout ===
                                            "split_canvas" && (
                                            <div className="tab">
                                              <button
                                                className={
                                                  activeTab === "London"
                                                    ? "tablinks active"
                                                    : "tablinks"
                                                }
                                                onClick={(event) => {
                                                  openCity(event, "London");
                                                  setActiveTab("London");
                                                }}
                                              >
                                                <span>
                                                  {SelectedLayout !==
                                                    "split_canvas" && (
                                                    <img src="assets/img/blog/left-table.png" />
                                                  )}
                                                </span>
                                                {SelectedLayout ===
                                                "split_canvas"
                                                  ? "Dyptychs-2 Panels"
                                                  : "Portrait"}
                                              </button>
                                              <button
                                                className={
                                                  activeTab === "Paris"
                                                    ? "tablinks active"
                                                    : "tablinks"
                                                }
                                                onClick={(event) => {
                                                  openCity(event, "Paris");
                                                  setActiveTab("Paris");
                                                }}
                                              >
                                                <span>
                                                  {SelectedLayout !==
                                                    "split_canvas" && (
                                                    <img src="assets/img/blog/left-table-2.png" />
                                                  )}
                                                </span>
                                                {SelectedLayout ===
                                                "split_canvas"
                                                  ? "Tryptychs-3 Panels"
                                                  : "Landscape"}
                                              </button>
                                            </div>
                                          )}
                                          {/* Tab content */}

                                          <div
                                            id="London"
                                            className="tabcontent"
                                            style={{
                                              display:
                                                activeTab === "London"
                                                  ? "block"
                                                  : "none",
                                            }}
                                          >
                                            <div className="main-control-table">
                                              <div className="pb-0  align-items-center ">
                                                <table className="table table-striped">
                                                  {SelectedLayout ===
                                                    "split_canvas" && (
                                                    <thead className="split-tabs-thead">
                                                      <tr>
                                                        <th>
                                                          DYPTYCHS - 2 PANELS
                                                        </th>
                                                        <th>STANDARD 3/4</th>
                                                        <th>THICK 1 1/2</th>
                                                      </tr>
                                                    </thead>
                                                  )}
                                                  {SelectedLayout !==
                                                    "split_canvas" && (
                                                    <tbody>
                                                      {SizeList &&
                                                        SizeList?.map(
                                                          (data, i) => (
                                                            <tr key={i}>
                                                              <td scope="row">
                                                                <input
                                                                  type="radio"
                                                                  id={i}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton1"
                                                                  onChange={() => {
                                                                    setSelectedSizeValue(
                                                                      data
                                                                    );
                                                                  }}
                                                                  checked={
                                                                    SelectedSizeValue.id ===
                                                                    data.id
                                                                  }
                                                                />
                                                                &nbsp;
                                                                <label
                                                                  htmlFor={i}
                                                                >
                                                                  {data?.size}
                                                                </label>
                                                              </td>
                                                              <td>
                                                                {data?.popular && (
                                                                  <button
                                                                    style={{
                                                                      background:
                                                                        "#0AA5C7",
                                                                      color:
                                                                        "#fff",
                                                                      padding: 5,
                                                                      fontSize:
                                                                        "small",
                                                                    }}
                                                                    className="px-2  btn-lg-sm"
                                                                  >
                                                                    <i
                                                                      className="fa-solid fa-star"
                                                                      style={{
                                                                        color:
                                                                          "#ffffff",
                                                                      }}
                                                                    />
                                                                    &nbsp;
                                                                    Popular
                                                                  </button>
                                                                )}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textDecoration:
                                                                    data?.discount_price
                                                                      ? "line-through"
                                                                      : "none",
                                                                      fontSize:'smaller'
                                                                }}
                                                              >
                                                                ${data?.price}
                                                              </td>
                                                              <td>
                                                                {data?.discount_price
                                                                  ? "$" +
                                                                    data?.discount_price
                                                                  : ""}
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                    </tbody>
                                                  )}

                                                  {SelectedLayout ===
                                                    "split_canvas" && (
                                                    <tbody className="split-tabs">
                                                      {SizeList &&
                                                        SizeList?.map(
                                                          (data, i) => (
                                                            <tr key={i}>
                                                              <td scope="row">
                                                                {data?.size}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                }}
                                                              >
                                                                <input
                                                                  type="radio"
                                                                  id={`s_${i}`}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton2"
                                                                  onChange={() =>
                                                                    setSelectedSizeValue(
                                                                      {
                                                                        id: data?.id,
                                                                        panels:
                                                                          data?.panels,
                                                                        price:
                                                                          data?.price,
                                                                        size: data?.size,
                                                                      }
                                                                    )
                                                                  }
                                                                  checked={
                                                                    SelectedSizeValue.id ===
                                                                      data.id &&
                                                                    SelectedSizeValue.price ===
                                                                      data?.price
                                                                  }
                                                                />
                                                                <label
                                                                  htmlFor={`s_${i}`}
                                                                >
                                                                  ${data?.price}
                                                                </label>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                }}
                                                              >
                                                                <input
                                                                  type="radio"
                                                                  id={`t_${i}`}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton3"
                                                                  onChange={() =>
                                                                    setSelectedSizeValue(
                                                                      {
                                                                        id: data?.id,
                                                                        panels:
                                                                          data?.panels,
                                                                        thick_price:
                                                                          data?.thick_price,
                                                                        size: data?.size,
                                                                      }
                                                                    )
                                                                  }
                                                                  checked={
                                                                    SelectedSizeValue.id ===
                                                                      data.id &&
                                                                    SelectedSizeValue.thick_price ===
                                                                      data?.thick_price
                                                                  }
                                                                />
                                                                <label
                                                                  htmlFor={`t_${i}`}
                                                                >
                                                                  $
                                                                  {
                                                                    data?.thick_price
                                                                  }
                                                                </label>
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                    </tbody>
                                                  )}
                                                </table>
                                                {!SelectedLayout && (
                                                  <div className="align-items-center d-flex justify-content-center mt-120 " style={{flexDirection:'column'}}>
                                                    <img src="assets/img/breadcrumb/defa_layout.png" alt="..." style={{height:'65px',width:'80px'}}/>
                                                    <p className="fw-semibold fs-5 mt-3">
                                                      Please Select Layout First
                                                    </p>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            id="Paris"
                                            className="tabcontent"
                                            style={{
                                              display:
                                                activeTab === "Paris"
                                                  ? "block"
                                                  : "none",
                                            }}
                                          >
                                            <div className="main-control-table">
                                              <div className="pb-0  align-items-center">
                                                <table className="table table-striped">
                                                  {SelectedLayout ===
                                                    "split_canvas" && (
                                                    <thead className="split-tabs-thead">
                                                      <tr>
                                                        <th>
                                                          DYPTYCHS - 2 PANELS
                                                        </th>
                                                        <th>STANDARD 3/4</th>
                                                        <th>THICK 1 1/2</th>
                                                      </tr>
                                                    </thead>
                                                  )}

                                                  {SelectedLayout !==
                                                    "split_canvas" && (
                                                    <tbody>
                                                      {SizeList &&
                                                        SizeList?.map(
                                                          (data, i) => (
                                                            <tr key={i}>
                                                              <td scope="row">
                                                                <input
                                                                  type="radio"
                                                                  id={i}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton4"
                                                                />
                                                                &nbsp;
                                                                <label
                                                                  htmlFor={i}
                                                                >
                                                                  {data?.size}
                                                                </label>
                                                              </td>
                                                              <td>
                                                                {data?.popular && (
                                                                  <button
                                                                    style={{
                                                                      background:
                                                                        "#0AA5C7",
                                                                      color:
                                                                        "#fff",
                                                                      padding: 5,
                                                                      fontSize:
                                                                        "small",
                                                                    }}
                                                                    className="px-2  btn-lg-sm"
                                                                  >
                                                                    <i
                                                                      className="fa-solid fa-star"
                                                                      style={{
                                                                        color:
                                                                          "#ffffff",
                                                                      }}
                                                                    />
                                                                    &nbsp;
                                                                    Popular
                                                                  </button>
                                                                )}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textDecoration:
                                                                    data?.discount_price
                                                                      ? "line-through"
                                                                      : "none",
                                                                }}
                                                              >
                                                                ${data?.price}
                                                              </td>
                                                              <td>
                                                                {data?.discount_price
                                                                  ? "$" +
                                                                    data?.discount_price
                                                                  : ""}
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}

                                                      {/* {SizeList &&
                                                SelectedLayout !==
                                                  "single_panel" &&
                                                SizeList?.map((data, i) => (
                                                  <tr>
                                                    <td scope="row">
                                                      <input
                                                        type="radio"
                                                        aria-label="Radio button for following text input"
                                                      />
                                                      &nbsp;
                                                      {data?.size}
                                                    </td>
                                                    <td>${data?.price}</td>
                                                  </tr>
                                                ))} */}
                                                    </tbody>
                                                  )}

                                                  {SelectedLayout ===
                                                    "split_canvas" && (
                                                    <tbody className="split-tabs">
                                                      {SizeList &&
                                                        SizeList?.map(
                                                          (data, i) => (
                                                            <tr key={i}>
                                                              <td scope="row">
                                                                {data?.size}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                }}
                                                              >
                                                                <input
                                                                  type="radio"
                                                                  id={`s_${i}`}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton5"
                                                                  onChange={() => {
                                                                    setSelectedSizeValue(
                                                                      {
                                                                        id: data?.id,
                                                                        panels:
                                                                          data?.panels,
                                                                        price:
                                                                          data?.price,
                                                                        size: data?.size,
                                                                      }
                                                                    );
                                                                  }}
                                                                  checked={
                                                                    SelectedSizeValue.id ===
                                                                      data.id &&
                                                                    SelectedSizeValue.price ===
                                                                      data?.price
                                                                  }
                                                                />
                                                                <label
                                                                  htmlFor={`s_${i}`}
                                                                >
                                                                  ${data?.price}
                                                                </label>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                }}
                                                              >
                                                                <input
                                                                  type="radio"
                                                                  id={`t_${i}`}
                                                                  aria-label="Radio button for following text input"
                                                                  name="sizeRadioButton6"
                                                                  onChange={() => {
                                                                    setSelectedSizeValue(
                                                                      {
                                                                        id: data?.id,
                                                                        panels:
                                                                          data?.panels,
                                                                        thick_price:
                                                                          data?.thick_price,
                                                                        size: data?.size,
                                                                      }
                                                                    );
                                                                  }}
                                                                  checked={
                                                                    SelectedSizeValue.id ===
                                                                      data.id &&
                                                                    SelectedSizeValue.thick_price ===
                                                                      data?.thick_price
                                                                  }
                                                                />
                                                                <label
                                                                  htmlFor={`t_${i}`}
                                                                >
                                                                  $
                                                                  {
                                                                    data?.thick_price
                                                                  }
                                                                </label>
                                                              </td>
                                                            </tr>
                                                          )
                                                        )}
                                                    </tbody>
                                                  )}
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-tab1"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab1-tab"
                                >
                                  <div className="row mt-20 ml-10">
                                    {/* <div className="col-xl-12 col-lg-12 col-md-12 ">
                          <h6 className=" heading">Photos</h6>
                          <p className="sub-heading">my photos (0)</p>
                        </div> */}
                                  </div>
                                  <div className="content-section">
                                    <div className="row mt-20 ">
                                      <div className="col-xl-12 col-lg-12 col-md-12 ">
                                        <div className="text-sub">
                                          Let’s get started by adding your
                                          photos!
                                        </div>
                                        <div className="dark-sub mt-10">
                                          Drag and drop or click in the boxes
                                          below.
                                        </div>
                                      </div>
                                      <div className="image-section mt-30 d-flex">
                                        <div className="col-xl-12 col-lg-12 col-md-12 text-center m-auto">
                                          <div className="text-sub">
                                            <label htmlFor="file-input">
                                              <img
                                                src="assets/img/breadcrumb/add-from-computer.png"
                                                alt=""
                                                style={{ cursor: "pointer" }}
                                              />
                                            </label>
                                            <input
                                              id="file-input"
                                              type="file"
                                              // multiple
                                              style={{ display: "none" }}
                                              onChange={OnImageChange}
                                            />
                                          </div>
                                        </div>
                                        {/*  <div class="col-xl-6 col-lg-6 col-md-12 ">
                                               <div class="dark-sub">
                                                   <img src="assets/img/breadcrumb/add-from-form.png" alt="">
                                               </div>
                                               </div> */}
                                      </div>
                                    </div>
                                    <div className="row mt-20  lower-btn">
                                      <div className="col-xl-12 col-lg-12 col-md-12 ">
                                        <div>
                                          <h6 className=" heading-connect mb-20">
                                            Or connect to other services to
                                            import:
                                          </h6>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-md-12 m-auto text-center">
                                          <a
                                            className="tp-btn-lg large head mb-10 social-icons"
                                            href="#"
                                          >
                                            <span>
                                              <i className="fa-brands fa-facebook-f" />
                                            </span>
                                            Facebook
                                          </a>
                                          <a
                                            className="tp-btn-lg large head mt-10 social-icons"
                                            href="#"
                                          >
                                            <span>
                                              <i className="fa-brands fa-apple" />
                                            </span>
                                            Instagram
                                          </a>
                                          <a
                                            className="tp-btn-lg large head mb-10 social-icons"
                                            href="#"
                                          >
                                            <span>
                                              <i className="fa-brands fa-apple" />
                                            </span>
                                            Apple iCloud
                                          </a>
                                          <a
                                            className="tp-btn-lg large head mt-10 social-icons"
                                            href="#"
                                          >
                                            <span>
                                              <i className="fa-brands fa-skype" />
                                            </span>
                                            Snapchat
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-tab4"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab4-tab"
                                > 
                                  <div className="tab-content">
                                    <div
                                      className="unselect p-2 table-wrapper-scroll-y tab-height first-li overflow-y-visible"
                                       
                                      // style={{ minHeight: "335px" }}
                                    >
                                      <div className="row">
                                      {(
                                        (SelectedLayout &&
                                          SelectedLayout !== "plexi_print" &&
                                          SelectedLayout !== "art_tray" &&
                                          SelectedLayout !== "wood_print") ||
                                         (FrameOption && FrameOption !== "framed")) && (
                                        <> 
                                          {EdgeListing && FrameOption !== "framed" &&
                                            EdgeListing.map((data, i) => (
                                          data?.availableIn.includes(SelectedLayout) &&   
                                           <div
                                                key={i}
                                                className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                                // style={{
                                                //   paddingRight:
                                                //     i % 2 === 0 ? "7px" : "",
                                                //   paddingLeft:
                                                //     i % 2 === 1 ? "7px" : "",
                                                // }}
                                              >
                                                <div className="tp-catagori-2__content-box mb-15">
                                                  <div
                                                    className={`${
                                                      Edge?.edge === data?.name
                                                        ? "selectedEdge"
                                                        : ""
                                                    } tp-catagori-2__content plr text-center py-2 pointer`}
                                                    onClick={() =>
                                                      setEdge({
                                                        edge: data?.name,
                                                        price:
                                                          data?.price === "0"
                                                            ? ""
                                                            : data?.price,
                                                      })
                                                    }
                                                  >
                                                    <img
                                                      className="w-32"
                                                      src={data?.image}
                                                      alt=""
                                                    />
                                                    <h4 className="tp-catagori-2__title text-white">
                                                      {data?.name}
                                                    </h4>
                                                    <p>{data?.description}</p>
                                                    <p className="box-range">
                                                      {data?.price === "0"
                                                        ? "No Charge"
                                                        : data?.price}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                        </>
                                      )}

                                      {FrameOption &&
                                        FrameOption === "framed" && (
                                          <>
                                            {FramedEdgeListing &&
                                              FramedEdgeListing.map(
                                                (data, i) => (
                                                  <div
                                                    key={i}
                                                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                                    // style={{
                                                    //   paddingRight:
                                                    //     i % 2 === 0
                                                    //       ? "7px"
                                                    //       : "",
                                                    //   paddingLeft:
                                                    //     i % 2 === 1
                                                    //       ? "7px"
                                                    //       : "",
                                                    // }}
                                                  >
                                                    <div className="tp-catagori-2__content-box mb-15">
                                                      <div
                                                        className={`${
                                                          Edge?.edge ===
                                                          data?.name
                                                            ? "selectedEdge"
                                                            : ""
                                                        } tp-catagori-2__content plr text-center py-2 pointer`}
                                                        onClick={() =>
                                                          setEdge({
                                                            edge: data?.name,
                                                            price:
                                                              data?.price ===
                                                              "0"
                                                                ? ""
                                                                : data?.price,
                                                          })
                                                        }
                                                      >
                                                        <img
                                                          className="w-32"
                                                          src={data?.image}
                                                          alt=""
                                                        />
                                                        <h4 className="tp-catagori-2__title text-white">
                                                          {data?.name}
                                                        </h4>
                                                        <p className="box-range">
                                                          {data?.price === "0"
                                                            ? "No Charge"
                                                            : `$${data?.price}`}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </>
                                        )}

                                      {!SelectedLayout && (
                                        <div className="align-items-center d-flex justify-content-center mt-120"  style={{flexDirection:'column'}}>
                                          <img src="assets/img/breadcrumb/defa_layout.png" alt="..." style={{height:'65px',width:'80px'}}/>
                                          <p className="fw-semibold fs-5 mt-3">
                                            Please Select Layout First
                                          </p>
                                        </div>
                                      )} 

                                      {SelectedLayout &&
                                        (SelectedLayout === "plexi_print" ||
                                          SelectedLayout === "art_tray" ||
                                          SelectedLayout === "wood_print") && (
                                          <div className="align-items-center d-flex justify-content-center " style={{flexDirection:'column'}}>
                                            <img src="assets/img/breadcrumb/def_edge.png" alt="..." style={{height:'65px',width:'80px'}}/>
                                            <p className="text-center text-sub mt-3">
                                              Edges are only available for
                                              CANVAS PRINTS
                                            </p>
                                          </div>
                                        )}
                                    </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-tab5"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab5-tab"
                                >
                                  <div className="tab-content">
                                    <div
                                      className="unselect p-2 table-wrapper-scroll-y tab-height first-li"
                                      style={{ overflowX: "hidden" }}
                                    >
                                      {SelectedLayout && (
                                        <>
                                          <div className="row additional-effect">
                                            <b className="mb-2">Effects:</b>
                                            {ServicesListing?.Effect &&
                                              ServicesListing?.Effect.map(
                                                (data, i) => (
                                                  <>
                                                    {(data?.isFree === "true" ||
                                                      data?.priceArray[0]
                                                        ?.price) && (
                                                      <div
                                                        key={i}
                                                        className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                                        // style={{
                                                        //   paddingRight:
                                                        //     i % 2 === 0
                                                        //       ? "7px"
                                                        //       : "",
                                                        //   paddingLeft:
                                                        //     i % 2 === 1
                                                        //       ? "7px"
                                                        //       : "",
                                                        // }}
                                                      >
                                                        <div className="tp-catagori-2__content-box mb-15">
                                                          <div
                                                            className={`${
                                                              Services?.Effects
                                                                ?.name ===
                                                              data?.name
                                                                ? "selectedEdge"
                                                                : ""
                                                            } tp-catagori-2__content plr text-center py-2 pointer`}
                                                            onClick={() =>
                                                              setServices(
                                                                (
                                                                  prevState
                                                                ) => ({
                                                                  ...prevState,
                                                                  Effects: {
                                                                    ...prevState.Effects,
                                                                    name: data?.name,
                                                                    price:
                                                                      data
                                                                        ?.priceArray[0]
                                                                        ?.price,
                                                                  },
                                                                })
                                                              )
                                                            }
                                                          >
                                                            <img
                                                              className="w-32"
                                                              style={{
                                                                height: "105px",
                                                                width: "165px",
                                                              }}
                                                              src={
                                                                data?.imageeffect
                                                              }
                                                              alt=""
                                                            />
                                                            <h4 className="tp-catagori-2__title text-white">
                                                              {data?.name}
                                                            </h4>
                                                            <p>
                                                              {
                                                                data?.description
                                                              }
                                                            </p>
                                                            <p className="box-range">
                                                              {data
                                                                ?.priceArray[0]
                                                                ?.price === ""
                                                                ? "No Charge"
                                                                : data?.name ===
                                                                  "Textured Canvas Coating"
                                                                ? `$${data?.priceArray[0]?.price} sq inch`
                                                                : `$${data?.priceArray[0]?.price}`}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </>
                                                )
                                              )}
                                          </div>

                                          <div className="row additional-effect mt-1">
                                            <b className="mb-2">Retouching:</b>
                                            {ServicesListing?.Retouching &&
                                              ServicesListing?.Retouching.map(
                                                (data, i) => (
                                                  <>
                                                    {(data?.isFree === "true" ||
                                                      data?.priceArray[0]
                                                        ?.price) && (
                                                      <div
                                                        key={i}
                                                        className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                                                        // style={{
                                                        //   paddingRight:
                                                        //     i % 2 === 0
                                                        //       ? "7px"
                                                        //       : "px",
                                                        //   paddingLeft:
                                                        //     i % 2 === 1
                                                        //       ? "7px"
                                                        //       : "",
                                                        // }}
                                                      >
                                                        <div className="tp-catagori-2__content-box mb-15">
                                                          <div
                                                            className={`${
                                                              Services
                                                                ?.Retouching
                                                                ?.name ===
                                                              data?.name
                                                                ? "selectedEdge"
                                                                : ""
                                                            } tp-catagori-2__content plr text-center py-2 pointer`}
                                                            onClick={() =>
                                                              setServices(
                                                                (
                                                                  prevState
                                                                ) => ({
                                                                  ...prevState,
                                                                  Retouching: {
                                                                    ...prevState.Retouching,
                                                                    name: data?.name,
                                                                    price:
                                                                      data
                                                                        ?.priceArray[0]
                                                                        ?.price,
                                                                  },
                                                                })
                                                              )
                                                            }
                                                          >
                                                            <img
                                                              className="w-32"
                                                              style={{
                                                                height: "105px",
                                                                width: "165px",
                                                              }}
                                                              src={
                                                                data?.imageeffect
                                                              }
                                                              alt=""
                                                            />
                                                            <h4 className="tp-catagori-2__title text-white">
                                                              {data?.name}
                                                            </h4>
                                                            <p>
                                                              {
                                                                data?.description
                                                              }
                                                            </p>
                                                            <p className="box-range">
                                                              {data
                                                                ?.priceArray[0]
                                                                ?.price === ""
                                                                ? "No Charge"
                                                                : `$${data?.priceArray[0]?.price}`}
                                                            </p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </>
                                                )
                                              )}
                                          </div>
                                        </>
                                      )}

                                      {!SelectedLayout && (
                                        <div className="align-items-center d-flex justify-content-center mt-120"  style={{flexDirection:'column'}}>
                                          <img src="assets/img/breadcrumb/defa_layout.png" alt="..." style={{height:'65px',width:'80px'}}/>
                                          <p className="fw-semibold fs-5 mt-3">
                                            Please Select Layout First
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* <div
                                  className="tab-pane fade"
                                  id="pills-tab5"
                                  role="tabpanel"
                                  aria-labelledby="pills-Tab5-tab"
                                >
                                  <div className="tab-content">
                                    <div
                                      className="row unselect p-2"
                                      style={{ minHeight: "440px" }}
                                    >
                                      <div className="additional-effect mt-3">
                                        <b>Effects:</b>
                                        <div className="select-items">
                                          <p>
                                            <input
                                              type="radio"
                                              defaultChecked="checked"
                                              defaultValue="No Effects"
                                              id="noneeffect"
                                              name="effectname"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Effects: {
                                                    ...prevState.Effects,
                                                    name: "None",
                                                    price: "",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> None</span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Black & White (No Charge)"
                                              id="blackeffect"
                                              name="effectname"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Effects: {
                                                    ...prevState.Effects,
                                                    name: "Black & White",
                                                    price: "",
                                                  },
                                                }))
                                              }
                                            />
                                            <span>
                                              {" "}
                                              Black &amp; White(No Charge)
                                            </span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Sepia (No Charge)"
                                              id="sepiaeffect"
                                              name="effectname"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Effects: {
                                                    ...prevState.Effects,
                                                    name: "Sepia",
                                                    price: "",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> Sepia(No Charge)</span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Textured Canvas Coating ($.25 sq inch)"
                                              id="imgeffect"
                                              name="effectname"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Effects: {
                                                    ...prevState.Effects,
                                                    name: "Textured Canvas Coating",
                                                    price: "0.25",
                                                  },
                                                }))
                                              }
                                            />
                                            <span>
                                              {" "}
                                              Textured Canvas Coating ($0.25 sq
                                              inch)
                                            </span>
                                          </p>
                                        </div>
                                      </div>

                                      <div className="additional-effect mb-3">
                                        <b>Retouching:</b>
                                        <div className="select-items">
                                          <p>
                                            <input
                                              type="radio"
                                              defaultChecked="checked"
                                              defaultValue="No Retouching"
                                              id="noneretouch"
                                              name="retouchstyle"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Retouching: {
                                                    ...prevState.Retouching,
                                                    name: "None",
                                                    price: "",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> None</span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Level One ($10.00)"
                                              id="oneretouch"
                                              name="retouchstyle"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Retouching: {
                                                    ...prevState.Retouching,
                                                    name: "Level One",
                                                    price: "10",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> Level One ($10.00)</span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Level Two ($20.00)"
                                              id="tworetouch"
                                              name="retouchstyle"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Retouching: {
                                                    ...prevState.Retouching,
                                                    name: "Level Two",
                                                    price: "20",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> Level Two ($20.00)</span>
                                          </p>
                                          <p>
                                            <input
                                              type="radio"
                                              defaultValue="Level Three ($30.00)"
                                              id="threeretouch"
                                              name="retouchstyle"
                                              onChange={() =>
                                                setServices((prevState) => ({
                                                  ...prevState,
                                                  Retouching: {
                                                    ...prevState.Retouching,
                                                    name: "Level Three",
                                                    price: "30",
                                                  },
                                                }))
                                              }
                                            />
                                            <span> Level Three ($30.00)</span>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          <div className=" ">
                          
                            {!Token && (
                              <a style={{ cursor: "pointer" }}>
                                <span
                                  className={`tp-btn-lg large head price two float-end mt-20 ${
                                    !EnableDisableAddToCart ? "disabled" : ""
                                  }`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#exampleModal"
                                  onClick={() =>
                                    setLoginModalOpen(!LoginModalOpen)
                                  }
                                >
                                  Add to Cart
                                </span>
                              </a>
                            )}

                            {Token && (
                              <> 
                              { isTab5Active && <button
                               className={`tp-btn-lg large head price two float-end mt-20 ${
                                 !EnableDisableAddToCart ? "disabled" : ""
                               }`}
                               onClick={() => {
                                 CheckUserLogin();
                               }}
                             >
                               Add to Cart
                             </button>}

                            {!isTab5Active && <button
                                className={`tp-btn-lg large head price two float-end mt-20  ${
                                   !EnableDisableAddToCart ? "disabled" : ""
                                }`}
                                onClick={() => {
                                  ChangeTabBlocks()
                                }}
                              > 
                                Continue
                              </button>}
                             </>
                            )}
                          </div>
                          </div>

                         
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <UpperFooterSlider />
        </main>

        {loading ? (
          <div className="LoaderSpinner">
            <BounceLoader
              color={"#607fe6"}
              loading={loading}
              speedMultiplier={2}
              size={50}
            />
            <div className="fw-semibold">Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div>
        <Login reset={LoginModalOpen} />
        <ForgotPassword />
      </div>
    </>
  );
}
